"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const country_code_lookup_1 = require("country-code-lookup");
const autosave_1 = require("../../../../hooks/autosave");
const TaskPage_1 = require("../../base/TaskPage");
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const constants_1 = require("../../../../tasks/constants");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Spacer_1 = require("../../../components/spacer/Spacer");
const Heading_1 = require("../../../components/heading/Heading");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const config_1 = require("./config");
const fullStory_1 = require("../../../../util/fullStory");
exports.default = (props) => {
    var _a;
    const { property, viewState, update, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const licenceRequirements = (_a = (0, config_1.getLicenceRequirements)(config_1.LocalLicenceCountries[(property === null || property === void 0 ? void 0 : property.country_code) || ''])) !== null && _a !== void 0 ? _a : (0, config_1.getLicenceRequirements)(config_1.LocalLicenceOptionalCountries[(property === null || property === void 0 ? void 0 : property.country_code) || '']);
    const country = (0, country_code_lookup_1.byIso)(property.country_code).country;
    React.useEffect(() => {
        (0, fullStory_1.sendCustomFullStoryEvent)('local_licence', {
            country
        });
    }, []);
    const overviewContent = licenceRequirements !== undefined
        ? `As your property is located in ${country}, we require you to provide the following information to publish your property on all channels.`
        : `Your property does not require any local licence information`;
    const helpLink = (licenceRequirements === null || licenceRequirements === void 0 ? void 0 : licenceRequirements.helpLink) !== undefined ?
        React.createElement(React.Fragment, null,
            " If you need help, please check out our ",
            React.createElement("a", { href: licenceRequirements.helpLink, target: "_blank" }, "guide"),
            ".") : null;
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.LOCAL_LICENCE, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(Heading_1.HeadingSmall, null, "Requirements"),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(Paragraph_1.Paragraph, null,
                        overviewContent,
                        helpLink),
                    licenceRequirements && React.createElement(React.Fragment, null,
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(licenceRequirements.Component, { property: property, update: update, requirements: licenceRequirements })))))));
};
//# sourceMappingURL=LocalLicencePage.js.map